<script>
	export let width = '60px'
</script>

<img src="/asset_arrow_up.svg" alt="" {width} />
